import { css, styled } from '../../../../../theme';

export const Overlay = styled.div<{ $visible: boolean }>`
  ${({ theme, $visible }) => css`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.5);
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    transition-duration: 200ms;
    opacity: ${$visible ? 1 : 0};
    visibility: ${$visible ? 'visible' : 'hidden'};
    pointer-events: auto;

    ${theme.tokens.media.down('desktop')} {
      padding-inline: ${theme.spacings.s};
      padding-top: ${theme.spacings.base};
      padding-bottom: ${theme.spacings.l};
    }
  `}
`;

export const SeekBar = styled.div`
  ${({ theme }) => css`
    position: relative;
    flex: 1;
    height: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 4px;
      background: ${theme.colors.gray[400]};
      border-radius: 4px;
      transition-duration: ${theme.tokens.animation.duration.base};
    }

    &:hover::before {
      height: 8px;
    }
  `}
`;

export const SeekFill = styled.div`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    height: 4px;
    background: #ffffff;
    border-radius: 4px;
    pointer-events: none;
    transition-duration: ${theme.tokens.animation.duration.base};

    ${SeekBar}:hover & {
      height: 8px;

      &::after {
        width: 16px;
        height: 16px;
      }
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateX(50%) translateY(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: inherit;
      transition-duration: ${theme.tokens.animation.duration.base};
    }
  `}
`;

export const IconWrapper = styled.button`
  padding: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;

  &:disabled {
    cursor: not-allowed;
  }
`;
